export default {
  label: {
    table: {
      header: {
        text: {
          domain: 'Channel',
          count: 'Total Active Messages',
        },
      },
    },
  },
};
